module.exports = __webpack_public_path__ + "media/images/lp/plight1-sp-be3d3e5d3aa085415956f5fef2efb37d.png";